import { render } from "./Slices.vue?vue&type=template&id=df129c18&scoped=true&ts=true"
import script from "./Slices.vue?vue&type=script&lang=ts"
export * from "./Slices.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df129c18"]])

export default __exports__